<template>
    <div class="login-card-outer" ref="form" id="sipDialler"></div>
</template>
<script>
  import { Web } from "sip.js";


  export default {


    data () {
      return {
        server : "wss://sip.example.com",
        simpleUser:null,
        options: null,
      }
    },

    components: {

    },

    created () {
     // this.options = new  Web.SimpleUserOptions = {
     //    aor: "sip:alice@example.com", // caller
     //    media: {
     //      constraints: { audio: true, video: false }, // audio only call
     //      remote: { audio: getAudioElement("remoteAudio") } // play remote audio
     //    }
     //  },
    this.simpleUser =   new Web.SimpleUser(this.server, options);
    },

    methods: {
  //      getAudioElement(id: string): HTMLAudioElement {
  //   const el = document.getElementById(id);
  //   if (!(el instanceof HTMLAudioElement)) {
  //     throw new Error(`Element "${id}" not found or not an audio element.`);
  //   }
  //   return el;
  // },

  // simpleUser.connect()
  //   .then(() => simpleUser.call("sip:bob@example.com"))
  //   .catch((error: Error) => {
  //     // Call failed
  //   });
    }
  }
</script>
